module.exports = "./app-dist/templates/pagination.directive.6388455f5a79e667aa3266eafad007a5.html";